import { create } from "zustand";
import { projectsApi } from "../api/projects";
import { bladesApi } from "../api/blades";

const useProjectStore = create((set, get) => ({
  projects: [],
  activeProject: null,
  activeDesign: null,
  loading: false,
  error: null,

  // ── Projects ──────────────────────────────────────────────────────
  fetchProjects: async () => {
    set({ loading: true, error: null });
    try {
      const { data } = await projectsApi.list();
      set({ projects: data, loading: false });
    } catch (e) {
      set({ error: e.message, loading: false });
    }
  },

  setActiveProject: (project) => set({ activeProject: project, activeDesign: null }),

  createProject: async (payload) => {
    const { data } = await projectsApi.create(payload);
    set((s) => ({ projects: [data, ...s.projects] }));
    return data;
  },

  updateProject: async (id, payload) => {
    const { data } = await projectsApi.update(id, payload);
    set((s) => ({
      projects: s.projects.map((p) => (p.id === id ? data : p)),
      activeProject: s.activeProject?.id === id ? data : s.activeProject,
    }));
    return data;
  },

  deleteProject: async (id) => {
    await projectsApi.remove(id);
    set((s) => ({
      projects: s.projects.filter((p) => p.id !== id),
      activeProject: s.activeProject?.id === id ? null : s.activeProject,
    }));
  },

  // ── Blade designs ─────────────────────────────────────────────────
  setActiveDesign: (design) => set((state) => ({
    activeDesign: {
      ...design,
      construction_lines: design.construction_lines ?? state.activeDesign?.construction_lines,
    },
  })),

  createDesign: async (payload) => {
    const { data } = await bladesApi.create(payload);
    set((s) => ({
      activeDesign: data,
      activeProject: s.activeProject
        ? { ...s.activeProject, blade_designs: [data, ...(s.activeProject.blade_designs || [])] }
        : s.activeProject,
    }));
    return data;
  },

  updateDesign: async (id, payload) => {
    const { data } = await bladesApi.update(id, payload);
    set((state) => ({
      activeDesign: {
        ...data,
        construction_lines: data.construction_lines ?? state.activeDesign?.construction_lines,
      },
    }));
    return data;
  },

  saveConstructionLines: async (designId, lines) => {
    const { data } = await bladesApi.saveConstructionLines(designId, lines);
    set({ activeDesign: data });
    return data;
  },
}));

export default useProjectStore;
